var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { registerSchema, registerUIComponent } from "../ComponentRegistry.js";
import "../types.js";
import { Component, Schema, type, defaultValue } from "../../decorators/type.js";
import { T as TransformSchema } from "../../Transform-9450b7b5.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import "../../utils/byteArray.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let EntityCameraSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "entity");
    __publicField(this, "zoom");
  }
};
__decorateClass([
  type("Entity"),
  defaultValue(-1)
], EntityCameraSchema.prototype, "entity", 2);
__decorateClass([
  type("number"),
  defaultValue(1)
], EntityCameraSchema.prototype, "zoom", 2);
EntityCameraSchema = __decorateClass([
  Component("EntityCamera")
], EntityCameraSchema);
registerSchema(ComponentCategory.CORE, EntityCameraSchema);
registerUIComponent("EntityCamera", (uiService, entity, gameModel, viewport) => {
  const data = gameModel.getTypedUnsafe(entity, EntityCameraSchema);
  if (data.entity > -1) {
    const transformSchema = gameModel.getTypedUnsafe(data.entity, TransformSchema);
    const position = transformSchema.position;
    viewport.moveCenter(position.x, position.y);
  }
});
export {
  EntityCameraSchema
};
//# sourceMappingURL=EntityCamera.js.map
